export default "__VITE_ASSET__25a55ff7__"